<template>
  <div class="nav-bar disabled-select">
    <div class="main flex-left">
      <router-link :to="item.path" :class="{'active': props.curNav === item.title}" v-for="item in navList" :key="item.tittle">{{item.title}}</router-link>
    </div>
  </div>
</template>

<script setup>
import { ref, defineProps } from 'vue'
const props = defineProps({
  curNav: String
})
const navList = [{ title: "首页", path: "/" }, { title: "产品中心", path: "/product" }, { title: "移动应用", path: "/mobile" }, { title: "服务与下载", path: "/serve" }, { title: "新闻资讯", path: "/newsList" }, { title: "联系我们", path: "aboutUs" },{ title: "加入我们", path: "joinUs" }]
</script>

<style scoped lang="scss">
.nav-bar {
  $nav-height: 40px;
  border: solid 1px $master-color;
  height: $nav-height;
  margin: 0 auto;
  background: $master-color;
  &>.main {
    height: $nav-height;
    p,a {
      color:#fff;
      height: $nav-height;
      line-height: $nav-height;
      padding: 0 30px;
      transition: all .3s;
      @extend .pointer;
      &.active {
        background: #fff;
        color: $master-color;
      }
      &:hover {
        background: #fff;
        color: $master-color;
      }
    }
  }
}
</style>
